import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { SHIFT_TYPES, weekLabel } from './scheduleUtils';

export const WeekNav = ({ monday, onPrev, onNext, onToday, right }) => (
  <div className="flex flex-wrap items-center gap-3 mb-4">
    <div className="flex items-center gap-1">
      <Button variant="outline" size="icon" onClick={onPrev} data-testid="schedule-prev-week"><ChevronLeft className="w-4 h-4" /></Button>
      <Button variant="outline" onClick={onToday} data-testid="schedule-this-week">This week</Button>
      <Button variant="outline" size="icon" onClick={onNext} data-testid="schedule-next-week"><ChevronRight className="w-4 h-4" /></Button>
    </div>
    <h2 className="text-base md:text-lg font-semibold text-slate-800" data-testid="schedule-week-label">{weekLabel(monday)}</h2>
    <div className="hidden md:flex items-center gap-3 ml-2 text-xs text-slate-500">
      {SHIFT_TYPES.map((t) => <span key={t.value} className="flex items-center gap-1"><span className={`w-2 h-2 rounded-full ${t.dot}`} />{t.label}</span>)}
      <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-violet-500" />Time off</span>
      <span className="text-slate-400" data-testid="schedule-tz-label">· all times MST</span>
    </div>
    {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
  </div>
);
